import { useQuery } from '@tanstack/react-query';

import Api from '@/services/api';
import { QUERY_KEYS } from '@/utils/query-keys';
import type { AxiosErrorResponse, BaseReportsPaginated, BaseReportsPaginatedResponse, PaginatedData } from '@/types';

export type ListAllLibertyMutualDTO = BaseReportsPaginated;

export type ListAllLibertyMutualResponse = PaginatedData<BaseReportsPaginatedResponse>;

async function listLibertyMutualPaginated(params: ListAllLibertyMutualDTO): Promise<ListAllLibertyMutualResponse> {
	const url = '/ergonomic-tool/liberty-mutual/reports/list-all';
	const { data } = await Api.get<ListAllLibertyMutualResponse>(url, {
		params
	});
	return data;
}

export const useListLibertyMutualPaginated = ({
	limit,
	offset,
	sector_id,
	company_id,
	cellule_id,
	report_name,
	activity_id,
	evaluator_id,
	original_name,
	created_at_end,
	workstation_id,
	organization_id,
	created_at_start,
	isSelectedReport
}: ListAllLibertyMutualDTO) => {
	const enabled = !!limit && !!isSelectedReport && offset >= 0;
	const libertyMutualReport = useQuery<ListAllLibertyMutualResponse, AxiosErrorResponse>(
		[
			QUERY_KEYS.GET_LIBERTY_MUTUAL_REPORTS_PAGINATED,
			[
				limit,
				offset,
				sector_id,
				company_id,
				cellule_id,
				report_name,
				activity_id,
				evaluator_id,
				original_name,
				created_at_end,
				workstation_id,
				organization_id,
				created_at_start
			]
		],
		() =>
			listLibertyMutualPaginated({
				limit,
				offset,
				sector_id,
				company_id,
				cellule_id,
				report_name,
				activity_id,
				evaluator_id,
				original_name,
				created_at_end,
				workstation_id,
				organization_id,
				created_at_start
			}),
		{
			enabled,
			retry: 0
		}
	);
	return libertyMutualReport;
};
